const License = () => import(
  /* webpackChunkName: "License" */
  './License');
export default {
  pages: [
    {
      path: 'license',
      name: 'license',
      component: License,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/manage-modules/License/index.js